const REPORTS = {
  channel: {
    label: "Revenue by Channel",
    stat: null,
    bars: [
      { name: "Organic", value: 100 },
      { name: "Paid", value: 78 },
      { name: "Email", value: 52 },
      { name: "Social", value: 34 },
    ],
  },
  churn: {
    label: "Churn Risk This Week",
    stat: "3 accounts",
    caption: "usage down 40%+, all inactive 9+ days",
  },
  quarter: {
    label: "vs. Last Quarter",
    stat: "+18.4%",
    caption: "MRR growth, driven by expansion revenue",
  },
}

const detectReport = (text) => {
  const t = text.trim().toLowerCase()
  if (t.includes("churn") || t.includes("risk")) return "churn"
  if (t.includes("quarter") || t.includes("compare")) return "quarter"
  if (t.includes("channel") || t.length === 0) return "channel"
  return "channel"
}

document.querySelectorAll("[data-canvas-demo]").forEach((el) => {
  const form = el.querySelector("[data-canvas-form]")
  const input = el.querySelector("[data-canvas-input]")
  const chips = el.querySelectorAll("[data-canvas-chip]")
  const node = el.querySelector("[data-canvas-new-node]")
  const line = el.querySelector("[data-canvas-line-right]")
  const placeholder = el.querySelector("[data-canvas-placeholder]")
  const brewing = el.querySelector("[data-canvas-brewing]")
  const result = el.querySelector("[data-canvas-result]")

  const render = (key) => {
    const report = REPORTS[key] || REPORTS.channel

    placeholder.classList.add("hidden")
    brewing.classList.remove("hidden")
    line.classList.add("stroke-primary", "dark:stroke-cyan-electric")
    node.classList.remove("border-dashed", "bg-mist")
    node.classList.add("border-solid", "bg-white", "dark:bg-white/5")

    setTimeout(() => {
      brewing.classList.add("hidden")
      result.classList.remove("hidden")
      result.innerHTML = ""

      const title = document.createElement("p")
      title.className = "text-[10px] font-semibold uppercase tracking-wide text-primary dark:text-cyan-electric"
      title.textContent = report.label
      result.appendChild(title)

      if (report.bars) {
        const barsWrap = document.createElement("div")
        barsWrap.className = "mt-2 flex h-10 items-end gap-1"
        report.bars.forEach((bar) => {
          const barEl = document.createElement("div")
          barEl.className = "w-full rounded-t bg-primary dark:bg-cyan-electric"
          barEl.style.height = "0%"
          barsWrap.appendChild(barEl)
          requestAnimationFrame(() => {
            barEl.style.transition = "height 0.6s ease"
            barEl.style.height = `${bar.value}%`
          })
        })
        result.appendChild(barsWrap)
      } else {
        const stat = document.createElement("p")
        stat.className = "mt-1 font-heading text-lg font-bold text-navy dark:text-white"
        stat.textContent = report.stat
        result.appendChild(stat)

        const caption = document.createElement("p")
        caption.className = "mt-0.5 text-[10px] leading-snug text-slate-500 dark:text-slate-body"
        caption.textContent = report.caption
        result.appendChild(caption)
      }
    }, 700)
  }

  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      input.value = chip.textContent.trim()
      render(chip.dataset.canvasChip)
    })
  })

  if (form) {
    form.addEventListener("submit", (event) => {
      event.preventDefault()
      render(detectReport(input.value))
    })
  }
})
